<template lang="pug">
v-card(:to="to", :width="width", width="300px")
  v-img(:src="img + '?resize=1&w=300'", :aspect-ratio="1.3", :alt="title")
  v-card-title.black--text.text-uppercase.font-weight-bold.project-card-title.text-body-1(
    v-html="title"
  )
  v-card-text.black--text {{ textWithoutHTML }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "100%",
    },
  },

  computed: {
    textWithoutHTML() {
      let d = document.createElement("div");
      d.innerHTML = this.text;
      return d.textContent;
    },
  },
};
</script>

<style>
.project-card-title {
  line-height: 20px !important;
}
</style>
